module.exports = __webpack_public_path__ + "img/fidc-bg-2.4e6e1dcb.png";